export const analyticsComponent = 'jiraRealtime';
export const analyticEvents = {
	EVENT_RECEIVED: 'eventReceived',
	FAILURE: 'errorReceived',
	JOINED_CHANNEL: 'joinedChannel',
	LEFT_CHANNEL: 'leftChannel',
};
